// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcomeText {
    text-align: center;
    color: white;
}

.returnButtonContainerAdmin {
    position: absolute;
    right: 0.5em;
    top: 8em;
    z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/AdminDashboard/AdminDashboard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,UAAU;AACd","sourcesContent":[".welcomeText {\n    text-align: center;\n    color: white;\n}\n\n.returnButtonContainerAdmin {\n    position: absolute;\n    right: 0.5em;\n    top: 8em;\n    z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
